export default __webpack_public_path__ + "static/media/sharkie-present-inverse.cb029350.svg";